var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { I18NLink, Translate } from "../I18N";
import { Icon } from "../UI";
import React, { useRef, useState, useCallback } from 'react';
import { useOnClickOutsideElement } from "../utils/useOnClickOutsideElementHook";


















export const DropdownMenu = ({ link, position }) => {
  const [showing, setShowing] = useState(false);
  const dropdownRef = useRef(null);
  const onClickOutside = useCallback(() => {
    setShowing(false);
  }, []);

  const toggleShowingWithoutPropagation = (e) => {
    setShowing(!showing);
    e.stopPropagation();
  };
  const toggleShowing = () => {
    setShowing(!showing);
  };

  useOnClickOutsideElement(dropdownRef, onClickOutside);

  return /*#__PURE__*/(
    React.createElement("li", { className: "menuNav-item", key: position, ref: dropdownRef }, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: `btn menuNav-btn menuNav-link dropdown-toggle ${showing ? 'expanded' : ''} `,
      id: "navbarDropdownMenuLink",
      onClick: toggleShowingWithoutPropagation }, void 0, /*#__PURE__*/

    _jsx(Translate, { context: "Menu" }, void 0, link.get('title')), "\xA0 ", /*#__PURE__*/
    _jsx(Icon, { icon: "caret-down" })), /*#__PURE__*/

    _jsx("ul", { className: `dropdown-menu ${showing ? 'expanded' : ''} ` }, void 0,
    link.get('sublinks').map((sublink, index) => {
      const url = (sublink === null || sublink === void 0 ? void 0 : sublink.get('url')) || '/';
      if (url.startsWith('http')) {
        return /*#__PURE__*/(
          _jsx("li", {}, index, /*#__PURE__*/
          _jsx("a", {
            href: url,
            className: "btn dropdown-item",
            target: "_blank",
            rel: "noreferrer",
            onClick: toggleShowing }, void 0, /*#__PURE__*/

          _jsx(Translate, { context: "Menu" }, void 0, sublink === null || sublink === void 0 ? void 0 : sublink.get('title')))));



      }
      return /*#__PURE__*/(
        _jsx("li", {}, index, /*#__PURE__*/
        _jsx(I18NLink, { to: url, className: "btn dropdown-item", onClick: toggleShowing }, void 0, /*#__PURE__*/
        _jsx(Translate, { context: "Menu" }, void 0, sublink === null || sublink === void 0 ? void 0 : sublink.get('title')))));



    }))));



};